import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-sm font-medium text-black" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex items-center justify-between mb-3" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "overflow-hidden rounded-lg" }
const _hoisted_7 = {
  key: 0,
  class: "absolute top-3 right-3 flex items-center gap-2"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "flex items-center gap-2 mb-2 pr-20" }
const _hoisted_11 = { class: "text-lg" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "text-xs text-black mt-3 block"
}
const _hoisted_14 = {
  key: 0,
  class: "flex justify-center gap-2 mt-4"
}
const _hoisted_15 = ["onClick"]

import { ref, watch } from 'vue'
import type { NewsItem } from '@/api/announcements'

const STORAGE_KEY = 'announcements_collapsed'


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnouncementBanner',
  props: {
    announcements: {}
  },
  setup(__props: any) {



const isCollapsed = ref(localStorage.getItem(STORAGE_KEY) === 'true')
const currentIndex = ref(0)

watch(isCollapsed, (val) => {
  localStorage.setItem(STORAGE_KEY, String(val))
})

function prev() {
  if (currentIndex.value > 0) currentIndex.value--
}

function next() {
  if (currentIndex.value < 100) currentIndex.value++
}

function typeIcon(type: string | null) {
  switch (type) {
    case 'warning':
      return '⚠️'
    case 'important':
      return '🔴'
    default:
      return 'ℹ️'
  }
}

function formatDate(dateStr: string) {
  try {
    return new Date(dateStr).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  } catch {
    return dateStr
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.announcements.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isCollapsed.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex items-center justify-between rounded-lg bg-gray-50 px-4 py-3 cursor-pointer border border-gray-200 hover:bg-gray-100 transition-colors",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapsed.value = false))
            }, [
              _createElementVNode("span", _hoisted_2, " 📢 Vous avez " + _toDisplayString(_ctx.announcements.length) + " annonce" + _toDisplayString(_ctx.announcements.length > 1 ? 's' : ''), 1),
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                class: "h-4 w-4 text-black",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                })
              ], -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-sm font-semibold text-black uppercase tracking-wide" }, "Actualités", -1)),
                _createElementVNode("button", {
                  class: "text-xs text-black hover:text-black transition-colors",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isCollapsed.value = true))
                }, " Réduire ▲ ")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "flex transition-transform duration-500 ease-in-out",
                    style: _normalizeStyle({ transform: `translateX(-${currentIndex.value * 100}%)` })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "w-full flex-shrink-0"
                      }, [
                        _createElementVNode("div", {
                          class: "relative rounded-xl border border-gray-200 p-5 shadow-sm h-full",
                          style: _normalizeStyle({ backgroundColor: item.bgColor || '#ffffff' })
                        }, [
                          (_ctx.announcements.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("button", {
                                  class: "w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 border border-gray-200 shadow-sm hover:bg-gray-200 hover:shadow transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed",
                                  disabled: currentIndex.value === 0,
                                  onClick: prev
                                }, _cache[4] || (_cache[4] = [
                                  _createElementVNode("svg", {
                                    class: "h-3 w-3 text-black",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      d: "M15 19l-7-7 7-7"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_8),
                                _createElementVNode("button", {
                                  class: "w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 border border-gray-200 shadow-sm hover:bg-gray-200 hover:shadow transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed",
                                  disabled: currentIndex.value === _ctx.announcements.length - 1,
                                  onClick: next
                                }, _cache[5] || (_cache[5] = [
                                  _createElementVNode("svg", {
                                    class: "h-3 w-3 text-black",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2.5",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      d: "M9 5l7 7-7 7"
                                    })
                                  ], -1)
                                ]), 8, _hoisted_9)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(typeIcon(item.type)), 1),
                            _createElementVNode("h4", {
                              class: "font-semibold",
                              style: _normalizeStyle({
                      color: item.titleColor || '#1a1a1a',
                      fontSize: item.titleFontSize || '15px',
                    })
                            }, _toDisplayString(item.title), 5)
                          ]),
                          _createElementVNode("div", {
                            class: "text-sm text-black leading-relaxed",
                            innerHTML: item.content
                          }, null, 8, _hoisted_12),
                          (item.dateCreation)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(formatDate(item.dateCreation)), 1))
                            : _createCommentVNode("", true)
                        ], 4)
                      ]))
                    }), 128))
                  ], 4)
                ])
              ]),
              (_ctx.announcements.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (_, idx) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: idx,
                        class: _normalizeClass(["w-2.5 h-2.5 rounded-full transition-all duration-300", idx === currentIndex.value ? 'bg-gray-700 scale-110' : 'bg-gray-300 hover:bg-gray-400']),
                        onClick: ($event: any) => (currentIndex.value = idx)
                      }, null, 10, _hoisted_15))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})